import { 
    API_ENDPOINTS, 
    customToast, 
    FormInput, 
    route, 
    SelectOption, 
    Stepper, 
    StringHelpers, 
    useDisabledContext, 
    useLangContext, 
    useQueries, 
    Variants 
} from "carrier-fe";
import { ToshibaInstallationFormData } from "../../pages/installation/toshiba/journey";
import { UseFormReturn } from "../../types/journey";
import { useEffect, useState } from "react";
import { QUERY_KEYS } from "../../util/Constants";
import { fetchProductModels } from "../../util/toshiba-utils";

type SelectKey = 'a2aProducts';
type Selects = Record<SelectKey, SelectOption[]>;

function ToshibaStep6({
    form,
    loading
}: {
    form: UseFormReturn<ToshibaInstallationFormData, any>,
    loading?: boolean,
}) {
    const { store, setValues, errors } = form;
    const { fields, crud } = useLangContext();
    const { disabled } = useDisabledContext();
    const [selects, setSelects] = useState<Selects>({
        a2aProducts: [],
    });

    const { 
        data: selectOptions, 
        error, 
        isLoading,
    } = useQueries<{ data: SelectOption[] }>([
        {
            key: QUERY_KEYS.PRODUCT_LINES,
            config: {
                method: 'GET',
                url: route(
                    API_ENDPOINTS.GENERIC.SELECT.PRODUCT.LINES
                )
            },
        },
    ]);

    useEffect(() => {
        if (!selectOptions) return;
        
        const productLines = selectOptions?.product_lines?.data;
        const a2aProductLine = productLines?.find(productLine => 
            productLine.label === 'A2A Heat Exchanger STD'
        );

        if (a2aProductLine) {
            fetchProductModels({ lineId: a2aProductLine.value })
            .then(a2aProductModels => 
                setSelects((prev) => ({
                    ...prev,
                    a2aProducts: a2aProductModels,
                }))
            );
        }
    }, [selectOptions]);

    useEffect(() => {
        if (!error) return;

        Object.values(error).map((e) =>
            customToast({ 
                title: (e?.response?.data as any)?.message, 
                variant: Variants.Danger 
            })
        );
    }, [error]);

    return (
        <Stepper.Step
            loading={isLoading || loading}
            title={fields?.a2a || 'A2A'}
            titleNotCapitalised
        >
            <FormInput
                name='a2a_product_id'
                type='searchable-select'
                label={fields?.model
                    || 'Model'
                }
                disabled={disabled}
                options={selects.a2aProducts}
                value={store?.additional_a2a.product_id}
                onChange={(value) => {
                    if (typeof value !== 'string') return;

                    setValues({
                        additional_a2a: {
                            ...store?.additional_a2a,
                            product_id: value,
                        }
                    });
                }}
                errorMessages={errors?.['additional_a2a.product_id']}
                clearable={false}
            />

            <FormInput
                name='a2a_serial_number'
                type='text'
                label={StringHelpers.title(
                    fields?.serial_number
                    || 'serial number'
                )}
                disabled={disabled}
                value={store?.additional_a2a?.serial_number}
                onChange={(value) => {
                    if (typeof value !== 'string') return;

                    setValues({
                        additional_a2a: {
                            ...store?.additional_a2a,
                            serial_number: value,
                        }
                    });
                }}
                errorMessages={errors?.['additional_a2a.serial_number']}
            />

            <FormInput
                name='a2a_installation_location'
                type='text'
                label={
                    `${crud?.models?.installation 
                        || 'Installation'} ${
                    fields?.location 
                        || 'Location'
                    }`
                }
                disabled={disabled}
                value={store?.additional_a2a?.installation_location}
                onChange={(value) => {
                    if (typeof value !== 'string') return;
                    
                    setValues({
                        additional_a2a: {
                            ...store?.additional_a2a,
                            installation_location: value,
                        }
                    });
                }}
                errorMessages={errors?.['additional_a2a.installation_location']}
            />
        </Stepper.Step>
    );
};

export default ToshibaStep6;
